/* Toont de zwevende bestelbalk zodra de gewone bestelknop uit beeld is. */
class AsnStickyAtc extends HTMLElement {
  connectedCallback() {
    const knop = document.querySelector('.asn-pdp__kopen .product-form__submit');
    if (!knop) return;

    this.waarnemer = new IntersectionObserver(
      ([item]) => {
        this.hidden = item.isIntersecting || item.boundingClientRect.top > 0;
      },
      { rootMargin: '0px 0px -100px 0px' }
    );
    this.waarnemer.observe(knop);
  }

  disconnectedCallback() {
    this.waarnemer?.disconnect();
  }
}

customElements.define('asn-sticky-atc', AsnStickyAtc);
